import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M17.4 12.9C17.4 13.395 16.995 13.8 16.5 13.8H12.9C11.91 13.8 11.1 12.99 11.1 12V7.5C11.1 7.005 11.505 6.6 12 6.6C12.495 6.6 12.9 7.005 12.9 7.5V11.1C12.9 11.595 13.305 12 13.8 12H16.5C16.995 12 17.4 12.405 17.4 12.9ZM21 12C21 16.968 16.968 21 12 21C7.032 21 3 16.968 3 12C3 7.032 7.032 3 12 3C16.968 3 21 7.032 21 12ZM19.2 12C19.2 8.031 15.969 4.8 12 4.8C8.031 4.8 4.8 8.031 4.8 12C4.8 15.969 8.031 19.2 12 19.2C15.969 19.2 19.2 15.969 19.2 12Z' />
        </SvgIcon>
    );
});
